/* Belly&Moi – améliorations conversion.
   1. [data-bm-delivery] : affiche une fourchette de dates de livraison (jours ouvrés, sans samedi ni dimanche).
   2. [data-bm-upsell] (panier) : ajoute les culottes manquantes pour atteindre le pack, puis recharge le panier.
      Les prix des packs viennent toujours des remises automatiques Shopify : ce script n'applique aucune remise.
   3. Page panier : après chaque requête panier terminée (/cart/change, /cart/update, /cart/add, /cart/clear),
      le récapitulatif (#main-cart-footer .js-contents) est rechargé. Les boutons + / − passent par un chemin
      du thème qui ne rafraîchissait que les articles : le total restait figé. */
(function () {
  function addBusinessDays(start, days) {
    var date = new Date(start.getTime());
    var left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) left -= 1;
    }
    return date;
  }

  function format(date) {
    try {
      return date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    } catch (e) {
      return date.getDate() + '/' + (date.getMonth() + 1);
    }
  }

  function renderDelivery(root) {
    (root || document).querySelectorAll('[data-bm-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 6;
      var max = parseInt(el.getAttribute('data-max'), 10) || 10;
      var prefix = el.getAttribute('data-prefix') || 'Livraison estimée';
      var today = new Date();
      el.innerHTML =
        prefix + ' entre le <strong>' + format(addBusinessDays(today, min)) +
        '</strong> et le <strong>' + format(addBusinessDays(today, max)) + '</strong>';
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-bm-upsell]');
    if (!button) return;
    event.preventDefault();
    var box = button.closest('.bm-upsell');
    var errorEl = box && box.querySelector('[data-bm-upsell-error]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    button.disabled = true;
    button.textContent = 'Ajout en cours…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.getAttribute('data-variant-id')), quantity: Number(button.getAttribute('data-quantity')) }],
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add');
        window.location.reload();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = button.getAttribute('data-label');
        if (errorEl) {
          errorEl.textContent = "Désolée, cette taille n'est plus disponible en quantité suffisante. Ajoutez une autre taille depuis la page produit.";
          errorEl.hidden = false;
        }
      });
  });

  // --- Récapitulatif du panier toujours à jour ---
  var CART_WRITE = /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/;
  var footerSectionId = null;
  var refreshTimer = null;
  var refreshCount = 0;

  function refreshCartFooter() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer || !footerSectionId) return;
    refreshCount += 1;
    // Pas d'en-tête Accept: application/json : sur /cart, il renverrait le JSON du panier au lieu des sections.
    var url = window.location.pathname + '?sections=' + encodeURIComponent(footerSectionId) + '&bm=' + refreshCount;
    fetch(url, { cache: 'no-store' })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var html = sections && sections[footerSectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.js-contents');
        var current = footer.querySelector('.js-contents');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var freshRoot = doc.getElementById('main-cart-footer');
        if (freshRoot) footer.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
      })
      .catch(function () {});
  }

  function scheduleFooterRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartFooter, 150);
  }

  function requestUrl(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    return input.url || String(input);
  }

  function initCartFooter() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    footerSectionId = footer.getAttribute('data-id');
    if (!window.fetch || window.__bmCartFetchWatch) return;
    window.__bmCartFetchWatch = true;
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var promise = originalFetch.apply(this, arguments);
      var url = requestUrl(input);
      if (CART_WRITE.test(url)) {
        promise.then(scheduleFooterRefresh, function () {});
      }
      return promise;
    };
  }

  function start() {
    renderDelivery();
    initCartFooter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (event) {
    renderDelivery(event.target);
  });
})();
